export default __webpack_public_path__ + "static/acting-info-img-de5cdbf722e9c2f73eb683bb491537fe.webp";